import styled from 'styled-components';

const HelpWrapper = styled.div`
  .dropdown-menu {
    min-width: 22rem;
    padding: 40px;
    border: 1px solid #fff;
    border-radius: 12px;
    box-shadow: 0px 35px 60px rgb(9 30 66 / 15%);
    right: 60px;
    top: 120px;
  }
  .dropdown-menu.left {
    left: 60px;
    right: auto;
    text-align: right;
  }
  .help-heading {
    font-style: normal;
    font-weight: 800;
    font-size: 1.1rem;
    color: #262626;
    width: 80%;
    line-height: initial;
  }
  .team-support {
    font-style: normal;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 140%;
    color: #4c565c;
    padding: 10px 0;
    margin-bottom: 10px;
  }
  .grey-border-bottom {
    border-bottom: 1px solid rgba(38, 38, 38, 0.1);
  }
  .pt-20 {
    padding-top: 20px;
  }
  .pb-20 {
    padding-bottom: 20px;
  }
  .ms-15 {
    margin-left: 15px;
  }
  .me-15 {
    margin-right: 15px;
  }
  .chat-with {
    font-style: normal;
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 140%;
    color: #4c565c;
  }
  .live-chat {
    font-style: normal;
    font-weight: 800;
    font-size: 1.3rem;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: #262626;
    & {
          body[dir='rtl'] & {
            direction:ltr !important;
          }
      }
    }
  }
`;


export default HelpWrapper;